var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { namespaces } from 'i18n/i18n.constants';
import { BoopTransition } from '@isyc-react/animation/modules/base/transition';
import { DeprecatedDropFile } from './deprecated-drop-file.component';
import { Spinner } from '@isyc-react/design/bootstrap';
import { fileToBase64 } from '@isyc-react/archives/utils';
import { useArchiveCreateFrontAndBackListInternalMutationPromise, useArchiveCreateInternalMutationPromise, useDocumentalRequestResolveMutationPromise, } from '@isyc-react/oc-api/queries';
import { ArchiveReceptionChannel } from '@isyc-react/types';
import { useNotificationHubContext } from '@isyc-react/form/modules/context';
import { NotificationItemType, RippleButton } from '@isyc-react/form/modules/base';
import { nanoid } from 'nanoid';
import { InputSelect } from '@isyc-react/form/modules/input/select';
import { awaitableApollo } from '@isyc-react/oc-api/apollo';
import { DocumentalRequestErrorCode } from './doc-request-fn';
import { DocumentTypeFormat } from 'common-app/override/types';
import { useArchiveCreateMultipleInternalMutationPromise } from 'common-app/override/oc-api';
import { DeprecatedMultiDropFile } from './multiple/deprecated-drop-multi-file.component';
const DocValidationFileMaxSize = 5000000; // 5 MB
const DocumentalValidationError = (props) => {
    const { code } = props;
    switch (code) {
        case DocumentalRequestErrorCode.NO_OPTION_SELECTED:
            return React.createElement("small", { className: 'text-red' }, "Aucune option documentaire n'a \u00E9t\u00E9 s\u00E9lectionn\u00E9e");
        case DocumentalRequestErrorCode.NO_ACCEPTED_FILE:
            return React.createElement("small", { className: 'text-red' }, "Aucun fichier valide n'a \u00E9t\u00E9 s\u00E9lectionn\u00E9");
        case DocumentalRequestErrorCode.LOW_FILE_QUALITY:
            return React.createElement("small", { className: 'text-red' }, "Le fichier a \u00E9t\u00E9 rejet\u00E9 en raison d'une mauvaise qualit\u00E9 d'image");
        case DocumentalRequestErrorCode.DOCUMENT_EDM_ERROR:
            return React.createElement("small", { className: 'text-red' }, "An error has occurred");
        default:
            return React.createElement(React.Fragment, null);
    }
};
export const DocGroupCardFile = props => {
    const { request, businessUnitId, relatedObjectTypeId, relatedId, onSuccess, obligatory, buttonUploadRef, onFinish } = props;
    // const nanoidNum = customAlphabet('1234567890', 3)
    // const idRefNum = React.useMemo(() => nanoidNum(7), [])
    const buttonRef = React.useRef(null);
    React.useEffect(() => {
        buttonUploadRef.push(buttonRef);
    }, []);
    const { t } = useTranslation(namespaces.common);
    const { addNotifications } = useNotificationHubContext();
    const archiveCreateMulti = useArchiveCreateMultipleInternalMutationPromise();
    const archiveCreateFB = useArchiveCreateFrontAndBackListInternalMutationPromise();
    const archiveCreateF = useArchiveCreateInternalMutationPromise();
    const documentationRequestResolve = useDocumentalRequestResolveMutationPromise();
    const [formatOpts, setFormatOpts] = React.useState(request.tFormatList);
    const [state, setState] = React.useState({
        errors: [],
        uploading: false,
        file: undefined,
        front: undefined,
        back: undefined,
        multi: undefined,
        selected: undefined,
        selectedFormat: request.tFormatList.length === 1 ? request.tFormatList[0] : undefined,
    });
    const documentalError = (remove, add) => {
        let newErrors = [...state.errors];
        let removed = false;
        remove.forEach(e => {
            let hadError = newErrors.indexOf(e);
            if (hadError !== -1) {
                removed = true;
                newErrors.splice(hadError, 1);
            }
        });
        let added = false;
        add.forEach(e => {
            let hadError = newErrors.indexOf(e);
            if (hadError === -1) {
                added = true;
                newErrors.push(e);
            }
        });
        return removed || added ? newErrors : state.errors;
    };
    const uploadError = (fileName) => {
        console.error('[Upload Error]');
        addNotifications([
            {
                type: NotificationItemType.ERROR,
                key: nanoid(),
                message: `Erreur lors du téléchargement du fichier ${fileName}`,
                life: 5000,
            },
        ]);
        const errors = documentalError([], [DocumentalRequestErrorCode.UPLOADING_ERROR]);
        setState(state => (Object.assign(Object.assign({}, state), { uploading: false, errors })));
    };
    const upload = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const { file, front, back, multi, selectedFormat } = state;
        if ((selectedFormat === DocumentTypeFormat.SINGLE && file) ||
            (selectedFormat === DocumentTypeFormat.FRONT_BACK && back && front) ||
            (selectedFormat === DocumentTypeFormat.MULTIPLE && multi)) {
            const uploadFileError = () => { var _a; return uploadError((_a = file === null || file === void 0 ? void 0 : file.name) !== null && _a !== void 0 ? _a : `${front === null || front === void 0 ? void 0 : front.name} - ${back === null || back === void 0 ? void 0 : back.name}`); };
            const documentalId = state.selected && request.tId === 0 ? state.selected : request.tId;
            let archive = undefined;
            if (state.selectedFormat === DocumentTypeFormat.SINGLE && file) {
                const query = { receptionChannelType: ArchiveReceptionChannel.WEB_PORTAL };
                const base64 = yield fileToBase64(file);
                query.content = base64;
                query.name = file.name;
                const response = yield awaitableApollo(archiveCreateF({
                    businessUnitId,
                    archiveCreateInternal: Object.assign({ relatedObjectTypeId,
                        relatedId, typologyTemplateIdList: [documentalId] }, query),
                }));
                if (response.error || response.errors || !response.data) {
                    uploadFileError();
                    onFinish && onFinish();
                    return;
                }
                archive = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.archive_createInternal;
            }
            if (state.selectedFormat === DocumentTypeFormat.FRONT_BACK && back && front) {
                const query = {
                    receptionChannelType: ArchiveReceptionChannel.WEB_PORTAL,
                };
                const base64Front = yield fileToBase64(front);
                const base64Back = yield fileToBase64(back);
                query.contentFront = base64Front;
                query.nameFront = front.name;
                query.contentBack = base64Back;
                query.nameBack = back.name;
                const response = yield awaitableApollo(archiveCreateFB({
                    businessUnitId,
                    archiveCreateFrontAndBackListInternal: [
                        Object.assign({ relatedObjectTypeId,
                            relatedId, typologyTemplateIdList: [documentalId] }, query),
                    ],
                }));
                if (response.error || response.errors || !response.data) {
                    uploadFileError();
                    onFinish && onFinish();
                    return;
                }
                archive = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.archive_createFrontAndBackListInternal[0];
            }
            if (state.selectedFormat === DocumentTypeFormat.MULTIPLE && multi) {
                const contentMulti = yield Promise.all(multi.map(fileToBase64));
                const contentName = multi.map(m => m.name);
                const response = yield awaitableApollo(archiveCreateMulti({
                    businessUnitId,
                    archiveCreateFrontAndBackInternal: {
                        relatedObjectTypeId,
                        relatedId,
                        receptionChannelType: ArchiveReceptionChannel.WEB_PORTAL,
                        typologyTemplateIdList: [documentalId],
                        contentList: contentMulti,
                        nameList: contentName,
                    },
                }));
                if (response.error || response.errors || !response.data) {
                    uploadFileError();
                    onFinish && onFinish();
                    return;
                }
                archive = response.data.archive_createMultipleInternal;
            }
            if (request.docReqId && (archive === null || archive === void 0 ? void 0 : archive.id)) {
                const resolved = yield awaitableApollo(documentationRequestResolve({
                    documentRequestId: request.docReqId,
                }));
                if (resolved.error || resolved.errors || !resolved.data) {
                    uploadFileError();
                    onFinish && onFinish();
                    return;
                }
            }
            addNotifications([
                {
                    type: NotificationItemType.SUCCESS,
                    key: nanoid(),
                    message: `Succès du téléchargement du fichier`,
                    life: 5000,
                },
            ]);
            onSuccess && onSuccess(documentalId);
            onSuccess && ((_c = request.options) === null || _c === void 0 ? void 0 : _c.forEach(o => onSuccess(o.id)));
            onFinish && onFinish();
        }
    });
    const onAccepted = (target, file) => {
        let errors = documentalError([
            DocumentalRequestErrorCode.NO_ACCEPTED_FILE,
            DocumentalRequestErrorCode.REJECTED_FILE,
            DocumentalRequestErrorCode.LOW_FILE_QUALITY,
            DocumentalRequestErrorCode.DOCUMENT_EDM_ERROR,
            DocumentalRequestErrorCode.UPLOADING_ERROR,
        ], []);
        setState(Object.assign(Object.assign({}, state), { errors, [target]: file }));
    };
    const onAcceptedMulti = (target, files) => {
        let errors = documentalError([
            DocumentalRequestErrorCode.NO_ACCEPTED_FILE,
            DocumentalRequestErrorCode.REJECTED_FILE,
            DocumentalRequestErrorCode.LOW_FILE_QUALITY,
            DocumentalRequestErrorCode.DOCUMENT_EDM_ERROR,
            DocumentalRequestErrorCode.UPLOADING_ERROR,
        ], []);
        setState(Object.assign(Object.assign({}, state), { errors, [target]: files }));
    };
    const onRemoveAccepted = (target) => {
        let errors = documentalError([
            DocumentalRequestErrorCode.LOW_FILE_QUALITY,
            DocumentalRequestErrorCode.DOCUMENT_EDM_ERROR,
            DocumentalRequestErrorCode.UPLOADING_ERROR,
        ], []);
        setState(Object.assign(Object.assign({}, state), { errors, [target]: undefined }));
    };
    const onRejected = (target) => {
        let errors = documentalError([DocumentalRequestErrorCode.LOW_FILE_QUALITY, DocumentalRequestErrorCode.DOCUMENT_EDM_ERROR], [DocumentalRequestErrorCode.REJECTED_FILE]);
        setState(Object.assign(Object.assign({}, state), { errors, [target]: undefined }));
    };
    const onRemoveRejected = () => {
        let errors = documentalError([DocumentalRequestErrorCode.REJECTED_FILE], []);
        setState(Object.assign(Object.assign({}, state), { errors }));
    };
    const hasFile = React.useMemo(() => {
        return (Boolean(state.selectedFormat === DocumentTypeFormat.SINGLE && state.file) ||
            Boolean(state.selectedFormat === DocumentTypeFormat.FRONT_BACK && state.front && state.back) ||
            Boolean(state.selectedFormat === DocumentTypeFormat.MULTIPLE && state.multi));
    }, [state]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DeprecatedDropFile, { className: 'card border border-primary border-dashed rounded-0 bg-light h-100 p-4 mb-0', 
            // accept={['image/jpeg', 'image/png', 'image/tiff', 'image/x-tiff', 'application/pdf']}
            disabled: state.uploading ||
                !state.selectedFormat ||
                state.selectedFormat === DocumentTypeFormat.FRONT_BACK ||
                state.selectedFormat === DocumentTypeFormat.MULTIPLE ||
                (request.options && request.options.length > 0 && state.selected === undefined), maxSize: DocValidationFileMaxSize, disabledSelect: state.uploading, showDropFileStatus: state.selectedFormat !== DocumentTypeFormat.FRONT_BACK && state.selectedFormat !== DocumentTypeFormat.MULTIPLE, onAccepted: (file) => onAccepted('file', file), onRemoveAccepted: () => onRemoveAccepted('file'), onRejected: () => onRejected('file'), onRemoveRejected: () => onRemoveRejected(), options: request.options
                ? request.options.map(t => ({ value: t.documentTypeId.toString(), label: t.documentTypeName, data: t }))
                : undefined, onOptionSelected: option => {
                if (option) {
                    let errors = documentalError([DocumentalRequestErrorCode.NO_OPTION_SELECTED], []);
                    const docType = option.data;
                    setFormatOpts(docType.documentTypeFormatList);
                    setState(state => (Object.assign(Object.assign({}, state), { selected: parseInt(option.value), errors, selectedFormat: docType.documentTypeFormatList.length === 1 ? docType.documentTypeFormatList[0] : undefined })));
                }
            }, afterSelectChildren: React.createElement(React.Fragment, null,
                formatOpts.length > 1 && (React.createElement("div", { className: 'my-3' },
                    React.createElement(InputSelect, { isDisabled: state.uploading, isSearchable: false, isClearable: false, placeholder: 'Sélectionner le format', options: formatOpts.map(opt => ({
                            value: opt,
                            label: opt === DocumentTypeFormat.SINGLE
                                ? 'Unique'
                                : opt === DocumentTypeFormat.FRONT_BACK
                                    ? 'Recto et verso'
                                    : 'Multiple',
                        })), value: state.selectedFormat
                            ? {
                                value: state.selectedFormat,
                                label: state.selectedFormat === DocumentTypeFormat.SINGLE
                                    ? 'Unique'
                                    : state.selectedFormat === DocumentTypeFormat.FRONT_BACK
                                        ? 'Recto et verso'
                                        : 'Multiple',
                            }
                            : null, noOptionsMessage: ({ inputValue }) => `Aucune option pour ${inputValue}`, onChange: selected => {
                            if (selected && selected.value !== state.selectedFormat) {
                                setState(state => (Object.assign(Object.assign({}, state), { selectedFormat: selected.value, file: undefined, back: undefined, front: undefined, multi: undefined })));
                            }
                        } }))),
                state.selectedFormat === DocumentTypeFormat.MULTIPLE && (React.createElement(React.Fragment, null,
                    React.createElement(DeprecatedMultiDropFile, { className: 'card border border-primary border-dashed rounded-0 bg-light p-4 mb-0', maxSize: DocValidationFileMaxSize, disabled: state.uploading, onAccepted: (file) => onAcceptedMulti('multi', file), onRemoveAccepted: () => onRemoveAccepted('multi'), onRejected: () => onRejected('multi'), onRemoveRejected: () => onRemoveRejected() },
                        React.createElement("h4", { className: 'text-primary' }, "Vous pouvez charger plusieurs fichiers / pages")))),
                state.selectedFormat === DocumentTypeFormat.FRONT_BACK && (React.createElement(React.Fragment, null,
                    React.createElement(DeprecatedDropFile, { className: 'card border border-primary border-dashed rounded-0 bg-light p-4 mb-0', maxSize: DocValidationFileMaxSize, disabled: state.uploading, onAccepted: (file) => onAccepted('front', file), onRemoveAccepted: () => onRemoveAccepted('front'), onRejected: () => onRejected('front'), onRemoveRejected: () => onRemoveRejected() },
                        React.createElement("h4", { className: 'text-primary' },
                            "Recto ",
                            React.createElement("span", { className: 'required' }, "*"))),
                    React.createElement(DeprecatedDropFile, { className: 'card border border-primary border-dashed rounded-0 bg-light p-4 mb-0', maxSize: DocValidationFileMaxSize, disabled: state.uploading, onAccepted: (file) => onAccepted('back', file), onRemoveAccepted: () => onRemoveAccepted('back'), onRejected: () => onRejected('back'), onRemoveRejected: () => onRemoveRejected() },
                        React.createElement("h4", { className: 'text-primary' },
                            "Verso ",
                            React.createElement("span", { className: 'required' }, "*")))))) },
            React.createElement("div", { className: clsx('d-flex align-items-center justify-content-center mb-4', {
                    'mb-2': request.options && request.options.length,
                    // 'justify-content-between': hasFile || state.uploading || state.errors.length > 0,
                }), style: { minHeight: '40px' } },
                React.createElement("div", { className: clsx('m-1 d-flex flex-column align-items-center text-center font-size-17 font-weight-bold', {
                        'text-red': state.errors.length,
                        'text-primary': !state.errors.length,
                    }) },
                    React.createElement("div", null,
                        request.tName,
                        " ",
                        obligatory ? React.createElement("span", { className: 'text-danger' }, "*") : ''),
                    request.docReqId && React.createElement("div", { className: 'm-1 badge rounded-pill bg-secondary' }, "Demande documentaire")),
                React.createElement("div", null,
                    state.uploading && React.createElement(Spinner, { animation: 'border', size: 'sm' }),
                    React.createElement("div", { className: 'd-none' },
                        React.createElement(RippleButton, { disabled: !(hasFile || state.uploading), ref: buttonRef, className: 'btn btn-outline-primary d-flex align-items-center', onClick: () => {
                                setState(state => (Object.assign(Object.assign({}, state), { uploading: true })));
                                upload();
                            } },
                            React.createElement("span", null, "Envoyer"),
                            React.createElement("i", { className: 'mdi mdi-upload font-size-18' })))),
                (hasFile || state.uploading) && state.errors.length > 0 && (
                // <div>
                //   {state.uploading && <Spinner animation='border' size='sm' />}
                //   {hasFile && !state.uploading && (
                //     <div className='d-none'>
                //       {/* <div className='d-none'> */}
                //       <RippleButton
                //         ref={buttonUploadRef[idRefNum]}
                //         className='btn btn-outline-primary d-flex align-items-center'
                //         onClick={() => {
                //           setState(state => ({ ...state, uploading: true }))
                //           upload()
                //         }}
                //       >
                //         <span>Envoyer</span>
                //         <i className='mdi mdi-upload font-size-18'></i>
                //       </RippleButton>
                //     </div>
                //   )}
                // { (
                React.createElement(BoopTransition, { show: Boolean(state.errors.length), rotation: 45, timing: 100 },
                    React.createElement("i", { className: 'mdi mdi-close font-size-30 text-red' })))),
            state.errors.map((error, j) => (React.createElement("p", { key: j },
                React.createElement(DocumentalValidationError, { code: error })))))));
};
